// extracted by mini-css-extract-plugin
var _1 = "BugReport__indBase--ALchA CoreGeneral__robotoSlab--X8lgW";
var _2 = "BugReport__indPending--GE8NR BugReport__indBase--ALchA CoreGeneral__robotoSlab--X8lgW";
var _3 = "BugReport__indSuccess--a1IDO BugReport__indBase--ALchA CoreGeneral__robotoSlab--X8lgW";
var _4 = "BugReport__indicator--FSLJS";
export { _1 as "indBase", _2 as "indPending", _3 as "indSuccess", _4 as "indicator" }
